import React, { FC, useEffect, useState, ReactElement } from 'react';
import { SurveyWrapper } from '../../molecules/SurveyWrapper';
import { StyledFooter, StyledP, StyleWrapper } from './Footer.styles';
import { FooterProps } from './Footer.types';
import { Link, useCheckBreakpoint } from '@marriott/mi-ui-library';
import { brandColorSchemeGenerator } from '../../util/constants';
import clsx from 'clsx';
import { useCreateSurveyStore } from '../../store/createSurveyStore';
import { EditableComponent } from '@adobe/aem-react-editable-components';
import { useRouter } from 'next/router';

export const FooterWrapperConfig = {
  emptyLabel: 'Footer',
  isEmpty: false,
  resourceType: 'mi-aem-martech/components/footer',
};

export const FooterComp: FC<FooterProps> = (props: FooterProps) => {
  const { model } = props;
  const isMobileViewPort = !useCheckBreakpoint('viewportM');
  const isDesktopViewPort = !useCheckBreakpoint('viewportL');
  const lastIndex = model?.footerLinks?.length - 1;
  const { formData } = useCreateSurveyStore();

  const [propertyName, setPropertyName] = useState(null);
  const [propertyAddress, setPropertyAddress] = useState(null);

  useEffect(() => {
    setPropertyName(props.propertyName || formData?.property_config?.hotel_name);
    setPropertyAddress(props.propertyAddress || formData?.property_config?.hotel_location);
  }, [
    formData?.property_config?.hotel_name,
    formData?.property_config?.hotel_location,
    props?.propertyAddress,
    props?.propertyName,
  ]);

  const [brandCdSetPage, setBrandCdSetPage] = useState('');
  const [trackingPreference, setTrackingPreference] = useState<ReactElement | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    if (props?.brandCode) {
      if (props?.property_config?.non_branded_flg === 'Y') {
        setBrandCdSetPage(brandColorSchemeGenerator('NBF', 'footer'));
      } else {
        setBrandCdSetPage(brandColorSchemeGenerator(props?.brandCode, 'footer'));
      }
    } else {
      if (formData?.property_config?.non_branded_flg === 'Y') {
        setBrandCdSetPage(brandColorSchemeGenerator('NBF', 'footer'));
      } else {
        setBrandCdSetPage(
          brandColorSchemeGenerator(formData?.property_config?.brand_cd || formData?.brandCode, 'footer')
        );
      }
    }
    setTrackingPreference(<span id="teconsent" className="mt-multi-link__link"></span>);
  }, [formData?.property_config?.brand_cd, props?.brandCode]);

  // const sanitizedNode = DOMPurify.sanitize(trackingPreference, {
  //   RETURN_DOM: true,
  // });
  // const fragmentString = sanitizedNode.innerHTML;
  const router = useRouter();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const urlQueryParams: Record<string, any> = router.query;

  let loadingFalse = true;
  if (
    urlQueryParams['page'] &&
    (Object.values(urlQueryParams['page']).includes('dining') ||
      Object.values(urlQueryParams['page']).includes('experiences') ||
      Object.values(urlQueryParams['page']).includes('review') ||
      Object.values(urlQueryParams['page']).includes('thank-you') ||
      Object.values(urlQueryParams['page']).includes('dining.mi') ||
      Object.values(urlQueryParams['page']).includes('experiences.mi') ||
      Object.values(urlQueryParams['page']).includes('review.mi') ||
      Object.values(urlQueryParams['page']).includes('thank-you.mi'))
  ) {
    loadingFalse = false;
  }
  useEffect(() => {
    const liElem = document.querySelector('li#teconsent');
    const spanElem = document.querySelector('span#teconsent');

    if (liElem && spanElem) {
      const anchor = liElem.querySelector('a');
      if (anchor) {
        spanElem.appendChild(anchor); // Moves the anchor from <li> to <span>
      }
    }
  }, [formData?.property_config?.brand_cd, props?.brandCode]);

  useEffect(() => {
    if (
      props?.propertyName ||
      props?.propertyAddress ||
      props?.brandCode ||
      props?.isAuthorMode ||
      formData?.property_config?.brand_cd
    ) {
      setIsLoading(false);
    }
  }, [
    props?.propertyName,
    props?.propertyAddress,
    props?.brandCode,
    props?.isAuthorMode,
    formData?.property_config?.brand_cd,
  ]);

  const currentYear = new Date().getFullYear();
  const copyrightHtml = model?.copyright?.replace(/\d{4}/, String(currentYear)) ?? '';

  return (
    <SurveyWrapper
      marshaCode=""
      backgroundImage={''}
      className="brand-css"
      colorScheme={brandCdSetPage}
      env_api_tile_error_info=""
    >
      {isLoading && loadingFalse ? (
        <StyledFooter
          id="footer-wrapper-container"
          className="footer-wrapper"
          data-testid="footer"
          data-component-name="o-account-footer"
        >
          <div className="col-12">
            <div className="inner-container py-4">
              <StyledP className="accordion-item d-flex mb-3">
                <div className="skeleton-loader" style={{ width: '200px', height: '20px' }}></div>
                <span className="skeleton-loader" style={{ width: '100px', height: '20px', marginLeft: '10px' }}></span>
              </StyledP>

              <div className="footer-bottom-link-list mb-3">
                <div className="skeleton-loader" style={{ width: '120px', height: '16px' }}></div>

                {[...Array(5)].map((_, index) => (
                  <div key={`footer-link-skeleton-${index}`} className="footer-link-wrapper d-flex align-items-center">
                    <div className="skeleton-loader" style={{ width: '180px', height: '16px' }}></div>
                    <span
                      className="skeleton-loader"
                      style={{ width: '12px', height: '12px', marginLeft: '10px' }}
                    ></span>
                  </div>
                ))}
              </div>

              <div className="d-flex flex-column flex-md-row">
                <div
                  className="m-accordion-title copyright align-self-center m-0 skeleton-loader"
                  style={{ width: '300px', height: '16px' }}
                  data-testid="copyright-text"
                ></div>
              </div>
            </div>
          </div>
        </StyledFooter>
      ) : (
        <StyledFooter
          id="footer-wrapper-container"
          className="footer-wrapper"
          data-testid="footer"
          data-component-name="o-account-footer"
        >
          <div className={'col-12'}>
            <div className="inner-container py-4">
              <StyledP className="accordion-item d-flex mb-3">
                <div>
                  {propertyName && (
                    <>
                      {propertyName}&nbsp;
                      {isDesktopViewPort ? <br /> : '|'}
                    </>
                  )}
                </div>
                <span>&nbsp;{propertyAddress}</span>
              </StyledP>
              <div className="footer-bottom-link-list mb-3">
                <div>
                  {trackingPreference}
                  <span className={clsx(`icon-arrow-right ${isMobileViewPort ? 'mt-0' : 'mt-1'}`)}></span>
                </div>
                {model?.footerLinks?.map((footerLink, index) => (
                  <React.Fragment key={`footer-link-fragment-${index}`}>
                    <div className="mr-2">
                      {footerLink.linkPath.includes('about/your-privacy-rights.mi') && (
                        <Link
                          key={`footer-link-${index}`}
                          // text={footerLink.linkTitle}
                          linkClassName=""
                          linkHref={footerLink.linkPath}
                          linkType="internal"
                          target="_blank"
                        >
                          <img
                            className="ca__full-width-img"
                            alt="privacyIcon"
                            data-src="https://cache.marriott.com/aka-fonts/ccpa/privacyoptions29x14.png"
                            src="https://cache.marriott.com/aka-fonts/ccpa/privacyoptions29x14.png"
                          />
                        </Link>
                      )}
                    </div>
                    <div className="footer-link-wrapper">
                      <Link
                        key={`footer-link-${index}`}
                        text={footerLink.linkTitle}
                        linkClassName={'m-nav-link footer-link'}
                        linkHref={footerLink.linkPath}
                        linkType="internal"
                        target="_blank"
                      />
                      <span
                        key={`arrow-icon-${index}`}
                        className={clsx(
                          `icon-arrow-right ${isMobileViewPort ? 'mt-0' : 'mt-1'} ${
                            index === lastIndex ? 'hidden' : ''
                          }`
                        )}
                      ></span>
                    </div>
                  </React.Fragment>
                ))}
              </div>
              <div className="d-flex flex-column flex-md-row">
                <div
                  className="m-accordion-title copyright align-self-center m-0"
                  dangerouslySetInnerHTML={{ __html: copyrightHtml }}
                  data-testid="copyright-text"
                />
              </div>
            </div>
          </div>
        </StyledFooter>
      )}
    </SurveyWrapper>
  );
};

/* eslint-disable @typescript-eslint/no-explicit-any */
export const Footer = (props: any) => {
  return (
    <EditableComponent {...props}>
      <StyleWrapper>
        <div id="universal-footer" className="footer-container">
          <FooterComp {...props} />
        </div>
      </StyleWrapper>
    </EditableComponent>
  );
};
